
import { Component, Vue } from 'vue-property-decorator'
import { NewsService } from "@/services/news/NewsService"
import News from "@/types/news/news"
import { DateAndTimeHelper } from "@/helpers/DateAndTimeHelper"

@Component({
  components: {
  }
})
export default class NewsView extends Vue {
  private title: string | null = null
  private news: string[] = []
  private newNews: string | null = null
  private existingNews: News[] | null = null

  private dateTimeHelper = new DateAndTimeHelper()
  private newsService = new NewsService()

  private headers = [
    { text: this.$t('admin.news.date'), value: 'from', sortable: true, align: 'left' },
    { text: this.$t('admin.news.newsTitle'), value: 'title', sortable: false },
    { text: '', value: 'actions', sortable: false }
  ]

  created () {
    this.newsService.getAllNews()
      .then((news) => {
        this.existingNews = news
      }).catch((error) => {
        this.$store.dispatch('error/setError', error)
      })
  }

  private uploadNews () {
    if (!this.title) return
    this.newsService.storeNews(this.title, this.news)
      .then(() => {
        this.newsService.getAllNews()
          .then((news) => {
            this.existingNews = news
          })
      }).catch((error) => {
        this.$store.dispatch('error/setError', error)
      })
  }

  private deleteNews (news: News) {
    if (!news || !news.id) return
    this.newsService.removeNews(news.id)
      .then(() => {
        this.newsService.getAllNews()
          .then((news) => {
            this.existingNews = news
          })
      })
      .catch((error) => {
        this.$store.dispatch('error/setError', error)
      })
  }
}
